export default (context) => {
  const modules = {};

  context.keys().forEach((filename) => {
    let module = context(filename);

    // only to handle yml contexts, yml contexts don't have default
    if (module.default) {
      module = module.default;
    }

    modules[filename.replace('./', '').replace(/(?!\..*\.)\..*$/, '')] = module;
  });

  return modules;
};
